import React, { Component } from "react";
import s from "./styles.scss";
import { Styled } from "../../../../toolkit/decorators/Artifact";
import { TrackingClubesStore } from "../../../containers/comisionesMembresiaConfiguracion/trackingClubes/TrackingClubes.store";
import { TrackingClubesDispatcher } from "../../../containers/comisionesMembresiaConfiguracion/trackingClubes/TrackingClubes.dispatcher";
import FormBuilder from "../../../../toolkit/baseForms2/formBuilder/FormBuilder";
import { formConfig, Inputs, Buttons } from "./TrackingClubes.form";
import {
  errorNotification,
  successNotification
} from "../../../../utils/notifications";
import TrackingClubesTable from "./TrackingClubes.table";
import { formatPeriodo } from "../../../helpers/formatters";
import MembresiaTrackingClub from "../../../../types/MembresiaTrackingClub";
import IButtonBuilder from "../../../../toolkit/baseForms2/iButtonBuilder/IButtonBuilder";
import ConfirmModal from "../../common/confirmModal/confirmModal";
import { Alert } from "reactstrap";

interface Props extends TrackingClubesStore, TrackingClubesDispatcher {}

interface State {
  periodo: string | null;
  clubes: MembresiaTrackingClub[];
  formErrors: Set<number>;

  hasChanges: boolean;
  popupOpen: boolean;
  ignoredValues: { [key in Inputs]: any };

  saveKey: number;
}

@Styled(s)
export default class TrackingClubesComponent extends Component<Props, State> {
  state = {
    periodo: null,
    clubes: [],
    formErrors: new Set<number>(),

    hasChanges: false,
    popupOpen: false,
    ignoredValues: null,
    saveKey: 0
  };

  componentDidMount() {
    this.props.clearTracking();
  }

  componentWillUnmount() {
    this.props.clearTracking();
  }

  submit = async (values: { [key in Inputs]: any }) => {
    // Si se detectaron cambios, se debe confirmar el descarte.
    if (this.state.hasChanges) {
      this.setState({
        popupOpen: true,
        ignoredValues: values
      });

      return;
    }

    const periodo = `${values.anio || new Date().getFullYear()}-${
      values.mes
    }-01`;
    this.setState({ periodo });

    const preview = await this.props.getTrackingByPeriodo(periodo);

    if (preview.fulfilled) {
      successNotification("Metas consultadas correctamente.");

      this.setState({
        clubes: preview.membresiaTracking || [],
        formErrors: new Set()
      });
    } else {
      errorNotification(preview.gettingMembresiaTrackingError);
    }
  };

  ignoreChanges = async () => {
    const values = this.state.ignoredValues;
    const periodo = `${values.anio || new Date().getFullYear()}-${
      values.mes
    }-01`;

    // Recargar los datos después de guardar
    this.setState(
      {
        formErrors: new Set(),
        periodo
      },
      async () => {
        const preview = await this.props.getTrackingByPeriodo(periodo);

        if (preview.fulfilled) {
          successNotification("Metas consultadas correctamente.");

          this.setState({
            saveKey: this.state.saveKey + 1,
            clubes: preview.membresiaTracking || [],
            hasChanges: false,
            popupOpen: false,
            ignoredValues: null
          });
        } else {
          errorNotification(preview.gettingMembresiaTrackingError);
        }
      }
    );
  };

  handleUpdate = (
    index: number,
    updatedItem: MembresiaTrackingClub,
    hasError: boolean
  ) => {
    const { clubes, formErrors } = this.state;

    // Intencionalmente no se almacenan los cambios en el State
    if (!hasError) {
      clubes[index] = updatedItem;
      formErrors.delete(index);
      this.setState({ hasChanges: true });
    } else {
      formErrors.add(index);
    }
  };

  handleGuardar = async () => {
    const { clubes, periodo, formErrors } = this.state;

    if (!periodo) {
      errorNotification("Debe seleccionar un periodo");
      return;
    }

    if (!clubes || clubes.length === 0) {
      errorNotification("No hay datos para guardar");
      return;
    }

    // Validar si hay errores antes de guardar
    if (formErrors.size > 0) {
      const firstError = [...formErrors].sort((a, b) => a - b)[0];
      const club = clubes[firstError];

      errorNotification(`Valores erróneos en el club: ${club.clubNombre}`);
      return;
    }

    // Guardado de los cambios
    const preview = await this.props.postTracking(clubes);
    if (preview.fulfilled) {
      successNotification("Datos guardados exitosamente");

      // Recarga de datos guardados del periodo
      this.setState(
        {
          formErrors: new Set()
        },
        async () => {
          const reloadPreview = await this.props.getTrackingByPeriodo(periodo);

          if (reloadPreview.fulfilled) {
            this.setState({
              saveKey: this.state.saveKey + 1,
              clubes: reloadPreview.membresiaTracking || [],
              hasChanges: false,
              ignoredValues: null
            });
          } else {
            errorNotification(reloadPreview.gettingMembresiaTrackingError);
          }
        }
      );
    } else {
      errorNotification(preview.postingMembresiaTrackingError);
    }
  };

  render() {
    const { gettingMembresiaTracking, postingMembresiaTracking } = this.props;
    const { periodo, clubes } = this.state;

    return (
      <div className="container">
        <div style={{ height: "15px" }}></div>
        <div className={s.filterContainer}>
          <div className="row">
            <div className="col-md-3">
              <div
                style={{
                  marginTop: "40px",
                  padding: "0 8px",
                  background: "#eee",
                  maxHeight: "32px"
                }}
              >
                <h6 style={{ marginTop: "0" }}>
                  Periodo:{" "}
                  {periodo ? formatPeriodo(periodo) : "No seleccionado"}
                </h6>
              </div>
            </div>
            <div className="col-md-9">
              <div style={{ margin: "0 15px" }}>
                <FormBuilder<Inputs, Buttons>
                  config={formConfig}
                  submit={this.submit}
                  loading={gettingMembresiaTracking || postingMembresiaTracking}
                >
                  <IButtonBuilder
                    name="guardar"
                    label="Guardar"
                    onClick={this.handleGuardar}
                    processing={postingMembresiaTracking}
                    disabled={!clubes || clubes.length === 0}
                  />
                </FormBuilder>
              </div>
            </div>
          </div>
        </div>

        <Alert color="info">
          Las configuraciones establecidas en esta pantalla son informativas y
          no se considerarán para el cálculo de comisiones.
        </Alert>

        {!!clubes && !!clubes.length && (
          <div className={s.tableContainer}>
            <TrackingClubesTable
              periodo={this.state.periodo}
              data={clubes}
              onUpdate={this.handleUpdate}
              saveKey={this.state.saveKey}
            />
          </div>
        )}

        <ConfirmModal
          isOpen={this.state.popupOpen}
          title={"Confirme la búsqueda"}
          message={
            "Los cambios realizados se descartarán permanentemente, ¿Desea continuar?"
          }
          ok={this.ignoreChanges}
          cancel={() => this.setState({ popupOpen: false })}
        />
      </div>
    );
  }
}
